import React from 'react'
import { connect } from 'react-redux';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import ShippingSettings from './EditDeliveryCards/ShippingSettings';
import Summary from './EditDeliveryCards/Summary';

function EditDeliveryMethodView(props) {
    const { loading, shipping, formik, countries } = props
    return (
        <React.Fragment>
            <Summary
                shipping={shipping}
                loading={loading}
                formik={formik}
                countries={countries}
            />
            <ShippingSettings
                shipping={shipping}
                loading={loading}
                formik={formik}
                countries={countries}
            />
        </React.Fragment >
    )
}

const getDataFromStore = state => {
    return {
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditDeliveryMethodView)